import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Activity, CreditCard, LayoutGrid, LogOut, Package, Settings, Store, Trophy, Users } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutGrid, end: true },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/predictions", label: "Predictions", icon: Trophy },
  { to: "/admin/payments", label: "Payments", icon: CreditCard },
  { to: "/admin/settings", label: "Settings", icon: Settings },
  { to: "/admin/logs", label: "Activity Logs", icon: Activity },
];

const cls = ({ isActive }) =>
  `flex items-center gap-3 whitespace-nowrap rounded-xl px-3.5 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-emerald-500/10 text-emerald-300" : "text-slate-400 hover:bg-white/[0.04] hover:text-white"}`;

export default function AdminShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen lg:flex">
      <aside className="hidden w-64 shrink-0 flex-col border-r border-white/[0.06] bg-[#080b12] p-5 lg:flex lg:sticky lg:top-0 lg:h-screen">
        <Logo to="/admin" />
        <p className="mt-2 pl-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-amber-400">Admin console</p>
        <nav className="mt-8 flex flex-1 flex-col gap-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={cls} data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-2 border-t border-white/[0.06] pt-4">
          <Link to="/dashboard" className={cls({})} data-testid="admin-view-store"><Store size={17} /> View customer area</Link>
          <button onClick={async () => { await logout(); nav("/"); }} className={`${cls({})} w-full`} data-testid="admin-logout-btn">
            <LogOut size={17} /> Log out
          </button>
          <p className="truncate px-3.5 text-xs text-slate-500">{user?.phone}</p>
        </div>
      </aside>
      <div className="flex-1">
        <header className="sticky top-0 z-30 border-b border-white/[0.06] bg-[#0b0f17]/90 backdrop-blur-xl lg:hidden">
          <div className="flex h-14 items-center justify-between px-4">
            <Logo to="/admin" />
            <button onClick={async () => { await logout(); nav("/"); }} className="btn-ghost px-3 py-2" data-testid="admin-mobile-logout"><LogOut size={16} /></button>
          </div>
          <nav className="no-scrollbar flex gap-1 overflow-x-auto px-3 pb-2">
            {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.end} className={cls}><n.icon size={15} /> {n.label}</NavLink>)}
          </nav>
        </header>
        <main className="mx-auto max-w-6xl px-5 py-8 lg:px-10 lg:py-12"><Outlet /></main>
      </div>
    </div>
  );
}
